export { default as LegacyMinicart } from './LegacyMinicart';
